import { createFileRoute } from "@tanstack/react-router";

import { EngagementRulesPanel } from "@/components/crm/EngagementRulesPanel";
import { GovernancePanel } from "@/components/crm/GovernancePanel";

import { OrgPanel } from "@/components/crm/OrgPanel";
import { SalesShell } from "@/components/crm/SalesShell";
import { StagesPanel } from "@/components/crm/StagesPanel";
import { useOrg } from "@/lib/crm/useOrg";

export const Route = createFileRoute("/_authenticated/sales/settings")({
  head: () => ({
    meta: [
      { title: "Sales settings — MyPriorities" },
      {
        name: "description",
        content:
          "Configure your pipeline stages and probabilities, and manage who can see and edit the sales data.",
      },
      { property: "og:title", content: "Sales settings — MyPriorities" },
      {
        property: "og:description",
        content: "Your stages, your weightings, your permissions.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: SalesSettingsPage,
});

function SalesSettingsPage() {
  const org = useOrg();
  return (
    <SalesShell
      title="Sales settings"
      subtitle="Pipeline stages, probabilities and organisation access."
    >
      {({ orgId, userId, role }) => (
        <div className="grid gap-5">
          <StagesPanel orgId={orgId} userId={userId} />
          <EngagementRulesPanel organisation={org.data?.organisation ?? null} role={role} />
          <GovernancePanel orgId={orgId} userId={userId} />

          <OrgPanel organisation={org.data?.organisation ?? null} role={role} />
        </div>
      )}
    </SalesShell>
  );
}
